import React from 'react';
import styled from 'styled-components';
import CircularProgress from '@material-ui/core/CircularProgress'
import {makeStyles} from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";

const Loading = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const useStyles = makeStyles({
  root: {
    position: 'relative',
  }
});

export default ({isLoading, children, ...rest}) => {
  const classes = useStyles();

  if (isLoading) {
    console.log('Is loading');
    return <Button {...rest} disabled={true} classes={{root: classes.root}}>{children}
      <Loading>
        <CircularProgress size={12} />
      </Loading>
    </Button>;
  }
  else {
    return <Button {...rest}>{children}</Button>
  }
}